export default function backToTopBtn() {
  let top = $('#top')
  let backToTopBtn = $('#backToTopBtn')
  backToTopBtn.on('click', function() {
    $('html, body').animate({
      scrollTop: top.offset().top
    }, 800)
  })
}